import React, { useMemo } from "react";
import { Avatar } from "antd";

const SentMessageCell = ({ conversation }) => {
  
  const renderReadStatus = (status) => {
    switch (status) {
      case "sent":
        return <div style={{ color: "gray", fontSize: "12px" }}><svg width="10" viewBox="0 0 65 65" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M56.5 0H8.5C3.8086 0 0 3.8086 0 8.5V56.5C0 61.1914 3.8086 65 8.5 65H56.5C61.1914 65 65 61.1914 65 56.5V8.5C65 3.8086 61.1914 0 56.5 0ZM60 56.5C60 58.4297 58.4297 60 56.5 60H8.5C6.5703 60 5 58.4297 5 56.5V8.5C5 6.5703 6.5703 5 8.5 5H56.5C58.4297 5 60 6.5703 60 8.5V56.5ZM48.398 38.191C48.0386 39.2222 47.0699 39.8629 46.0386 39.8629C45.7574 39.8629 45.48 39.8121 45.2105 39.7223L31.6715 34.9528C30.6715 34.6012 29.9996 33.652 29.9996 32.5934V15.7224C29.9996 14.3435 31.1207 13.2224 32.4996 13.2224C33.8785 13.2224 34.9996 14.3435 34.9996 15.7224V30.8244L46.8706 35.0041C48.1714 35.465 48.8589 36.8947 48.4018 38.1955L48.398 38.191Z" /></svg></div>;
      case "delivered":
        return <div style={{ color: "gray", fontSize: "12px" }}><svg width="10" viewBox="0 0 68 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M66.7297 6.23125L26.3097 46.8343C24.7607 48.3913 22.2528 48.3893 20.7057 46.8303L0.57975 26.5663C-0.19325 25.7873 -0.19325 24.5212 0.57975 23.7423L3.38475 20.9202C4.15775 20.1412 5.41375 20.1412 6.18775 20.9202L22.1578 37.0003C22.9308 37.7793 24.1868 37.7793 24.9608 37.0003L61.1268 0.58425C61.8997 -0.19475 63.1558 -0.19475 63.9298 0.58425L66.7327 3.40625C67.5078 4.18825 67.5057 5.45225 66.7297 6.23125Z"/></svg></div>;
      case "read":
        return <div style={{ color: "#4fc3f7", fontSize: "12px" }}><svg width="14" viewBox="0 0 99 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M67.241 6.23101L26.821 46.834C25.272 48.391 22.764 48.389 21.217 46.83L1.09098 26.566C0.31798 25.787 0.31798 24.521 1.09098 23.742L3.89598 20.92C4.66898 20.141 5.92498 20.141 6.69898 20.92L22.669 37C23.442 37.779 24.698 37.779 25.472 37L61.638 0.584006C62.411 -0.194994 63.667 -0.194994 64.441 0.584006L67.244 3.40601C68.019 4.18801 68.017 5.45201 67.241 6.23101ZM97.938 3.40701L95.176 0.585005C94.414 -0.193995 93.176 -0.193995 92.414 0.585005L56.778 37C56.014 37.779 54.778 37.779 54.014 37L51.157 34.08C50.395 33.301 49.159 33.299 48.395 34.078L45.629 36.896C44.865 37.675 44.863 38.941 45.627 39.722L52.584 46.829C54.107 48.388 56.58 48.39 58.105 46.833L97.934 6.23001C98.701 5.45201 98.701 4.18601 97.938 3.40701Z"/></svg></div>;
      default:
        return null;
    }
  };
  
  const messageContent = useMemo(() => {
    return typeof conversation?.content === "object" &&
      conversation?.content?.messagetext
      ? conversation?.content?.messagetext
      : conversation?.content || conversation?.body || "Message not available";
  }, [conversation]);

  const formatMessageTime = (timestamp) => {
    const options = { 
      hour: '2-digit', 
      minute: '2-digit', 
      hour12: true // Ensures 12-hour format with AM/PM
    };
    return new Date(timestamp).toLocaleTimeString('en-US', options);
  };

  return (
    <div className={`gx-chat-item gx-flex-row-reverse SM ${conversation?.sender_type === 'partner' ? "whatsapp" : "internal"}`}>

      <Avatar className="gx-size-40 gx-align-self-end" src={require("assets/images/avatar/user.jpg")} alt={conversation.name} />

      <div className="gx-bubble-block">
        <div className="gx-bubble">
          <div className="gx-message" style={{ fontSize: '15px' }}>{messageContent}</div>
          <div className="gx-time gx-text-muted gx-text-right gx-mt-2" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            {conversation?.timestamp ? formatMessageTime(conversation.timestamp)
            : conversation?.created_at ? formatMessageTime(conversation.created_at)
            : "Time not available"}
            {/* Render read status after timestamp */}
            <span style={{ marginLeft: '5px', display: 'flex' }}>
              {renderReadStatus(conversation.status)}
            </span>
          </div>
        </div>
      </div>

    </div>
  );
};
  
export default SentMessageCell;
